"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cart = Cart;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _checkouts = require("@px/checkouts");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */

const Link = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Link",
  class: "pl-lbitmwu",
  vars: {
    "lbitmwu-8": [props => props.isEmpty ? 'none' : 'block']
  }
});
const CartTotalLink = /*#__PURE__*/(0, _react2.styled)(Link)({
  name: "CartTotalLink",
  class: "pl-c1kn2wp9",
  vars: {
    "c1kn2wp9-0": [props => props.isEmpty ? 'none' : 'block'],
    "c1kn2wp9-1": [props => props.useDarkText ? _intents.default.ux.box.foregroundColor : 'inherit'],
    "c1kn2wp9-2": [props => props?.cartTotal]
  }
});
const CartText = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "CartText",
  class: "pl-cpl9lvb",
  vars: {
    "cpl9lvb-1": [props => props.isEmpty ? 'none' : 'block']
  }
});
const HeaderCart = /*#__PURE__*/(0, _react2.styled)(_checkouts.Checkout)({
  name: "HeaderCart",
  class: "pl-h1hvwsds"
});
const CartFlyOut = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CartFlyOut",
  class: "pl-c1vxr25c"
});

/**
 * Cart icon with link.
 *
 * @param {Object} props React props
 * @param {string} props.href Cart Href
 * @param {number} props.items Item count representing how many items are in the cart
 * @param {boolean} props.showEmpty Show the empty cart icon, default false
 * @param {string} props.partial Partial theme
 * @returns {React.ReactElement} React HTML element
 * @public
 */
function Cart({
  href,
  ariaLabel,
  ctaText,
  id,
  _name,
  isEmpty,
  invert,
  partial,
  cartTotal,
  showCartTotal,
  useDarkText
}) {
  // Workaround that checks for Header Cart loader element in the DOM
  // TODO: Remove workaround by implementing a more sustainable pattern in CMS
  // Preserving this workaround for backwards compatibility
  const [hcLoader, setHCLoader] = (0, _react.useState)(false);
  const [configKey, setConfigKey] = (0, _react.useState)(null);
  const loaderId = '#id-1af7c6ea-177e-4d81-b844-de7a435c0463';
  (0, _react.useEffect)(() => {
    setHCLoader(!!document.querySelector(loaderId));
  }, []);
  (0, _react.useEffect)(() => {
    const element = document.querySelector('[data-configkey]');
    element && setConfigKey(element.getAttribute('data-configkey'));
  }, []);
  const key = configKey ? {
    configKey
  } : {};
  const dataPartial = partial || (invert ? 'dark1' : '');
  const cartProps = {
    ariaLabel,
    'data-partial': dataPartial,
    'title': ariaLabel,
    href,
    isEmpty
  };
  if (configKey || hcLoader) {
    return /*#__PURE__*/_react.default.createElement(CartFlyOut, (0, _extends2.default)({
      id: `id-hc-${id}`
    }, _patternLibraryUtils.tracking.create(_name, true, false)), /*#__PURE__*/_react.default.createElement(HeaderCart, (0, _extends2.default)({
      appKey: "FOS",
      checkoutName: "HeaderCart",
      id: `header-cart`,
      flyoutElementId: `id-hc-${id}`
    }, key)));
  } else if (showCartTotal) {
    return /*#__PURE__*/_react.default.createElement(CartTotalLink, (0, _extends2.default)({
      id: `id-${id}`,
      cartTotal: `"${cartTotal}"`,
      useDarkText: useDarkText,
      "data-cy": "cart"
    }, _patternLibraryUtils.tracking.create(_name, true, false), cartProps), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "cart"
    }), isEmpty && /*#__PURE__*/_react.default.createElement(CartText, {
      isEmpty: isEmpty
    }, ctaText));
  }
  return /*#__PURE__*/_react.default.createElement(Link, (0, _extends2.default)({
    id: `id-${id}`
  }, cartProps, _patternLibraryUtils.tracking.create(_name, true, false), {
    "data-cy": "cart"
  }), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "cart"
  }), /*#__PURE__*/_react.default.createElement(CartText, {
    isEmpty: isEmpty
  }, ctaText));
}
Cart.propTypes = {
  href: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  ctaText: _propTypes.default.string,
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  isEmpty: _propTypes.default.bool,
  cartTotal: _propTypes.default.number,
  showCartTotal: _propTypes.default.bool,
  useDarkText: _propTypes.default.bool
};